/**
 * Scroll so the hash target is vertically centered in the viewport.
 * Retries until the element exists (async route chunks / late render).
 */
export function scrollToAnchor(hash, { behavior = 'smooth', maxAttempts = 50, intervalMs = 50 } = {}) {
  if (!hash || typeof hash !== 'string') {
    return Promise.resolve(false)
  }

  const id = hash.startsWith('#') ? hash.slice(1) : hash
  if (!id) {
    return Promise.resolve(false)
  }

  return new Promise((resolve) => {
    let attempts = 0

    const tryScroll = () => {
      const el = document.getElementById(id)
      if (!el) {
        attempts += 1
        if (attempts < maxAttempts) {
          window.setTimeout(tryScroll, intervalMs)
          return
        }
        resolve(false)
        return
      }

      const rect = el.getBoundingClientRect()
      const absoluteTop = window.pageYOffset + rect.top
      const visibleHeight = Math.min(rect.height, window.innerHeight)
      const top = absoluteTop - (window.innerHeight - visibleHeight) / 2

      window.scrollTo({
        top: Math.max(0, top),
        behavior,
      })
      resolve(true)
    }

    requestAnimationFrame(tryScroll)
  })
}
